/**
 * Mirror `bulk-search-controller.js#prepareQueryValues`:
 * `_.words(values, /([^\s,]+[^,\r\n\t]*[^\s,]+|[^\s,]+)/g)`.
 */
const VALUE_PATTERN = /([^\s,]+[^,\r\n\t]*[^\s,]+|[^\s,]+)/g;

export function prepareQueryValues(values: string): string[] {
    return values.match(VALUE_PATTERN) ?? [];
}

export function buildBulkSearchName(date: Date = new Date()): string {
    return (
        `BulkSearch_${date.getDate()}_${date.getMonth() + 1}_${date.getFullYear()}`
        + `_${date.getHours()}_${date.getMinutes()}_${date.getSeconds()}`
    );
}

/**
 * Mirror `items-controller.js#openBulkSearchOnQueryTooLong`:
 * replace ` OR ` with newlines and count values.
 */
export function keywordToBulkSearchValues(keyword: string): {
    queryValues: string;
    queryTooLong: number;
} {
    const queryValues = keyword.replace(/ OR /g, '\n');
    const newlineCount = (queryValues.match(/\n/g) ?? []).length;
    return {
        queryValues,
        queryTooLong: newlineCount + 1,
    };
}
